module.exports = __webpack_public_path__ + "img/virtual-reality-dark.0dede335.svg";